/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HandbookSubCategory = {
    properties: {
        id: {
    type: 'number',
},
        categoryId: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        createdAt: {
    type: 'number',
},
    },
};